
/**
 * 결제 주기
 */
export type GetPlanChangeOptions200DowngradeOptionsItemBillingCycle = typeof GetPlanChangeOptions200DowngradeOptionsItemBillingCycle[keyof typeof GetPlanChangeOptions200DowngradeOptionsItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanChangeOptions200DowngradeOptionsItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
